import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import LoadingComponent from '../../components/LoadingComponent';

export type MenuItemProps = {
  title: string;
  url: string;
  menus?: { [title: string]: string };
  src?: string;
  onClick: () => void;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  loading?: React.RefObject<LoadingComponent | null>;
};

function MenuItem(props: MenuItemProps) {
  const location = useLocation();
  const navigate = useNavigate();

  const onClick = () => {
    props.onClick();
  };

  const navigateToLink = (e: React.MouseEvent) => {
    e.preventDefault();
    const url = location.pathname;
    if (url == props.url) return;
    const kaz = (
      <>
        <div>K</div>
        <div>A</div>
        <div>Z</div>
      </>
    );
    const bars = [kaz];
    props.loading?.current?.setBars(bars);
    setTimeout(() => {
      props.loading?.current?.scrollAndLoadAnimation(url);
    }, 100);
    setTimeout(() => {
      navigate(props.url);
    }, 1000);
  };

  return (
    <>
      {props.src ? (
        <Link
          to={props.url}
          onClick={(e) => navigateToLink(e)}
          onMouseEnter={props?.onMouseEnter}
          onMouseLeave={props?.onMouseLeave}
        >
          <img src={props.src} alt={props.title} />
        </Link>
      ) : (
        <>
          <li className="menu-item nav-item" key={props.title.replace(' ', '_')} onClick={onClick}>
            <Link
              onClick={(e) => navigateToLink(e)}
              to={props.url}
              className={`nav-link ${location.pathname === props.url ? 'active' : ''}`}
            >
              {props.title}
            </Link>
          </li>
        </>
      )}
    </>
  );
}

export default MenuItem;
